import { IHisInfoGroupBehavior } from ".";
import { HisInformationItem } from "../..";
import { User } from "../../../user";
import { IHisInformationApplicable } from "../../../document/items";

export class DefaultUserBehavior implements IHisInfoGroupBehavior {
  constructor(private key: string, private users: User[]) {}

  createHisInfoItems(): HisInformationItem[] {
    if (this.users === null) { return [ new HisInformationItem(this.key, "") ]; }

    const values = this.users.map(x => x.name);
    const items = values.map(x => new HisInformationItem(this.key, x));
    return items;
  }

  areSameGroup(item: IHisInformationApplicable): boolean {
    return false;
  }
}
